export default {
  route: {
    dashboard: 'Dashboard',
    homeCollections: 'App Home Collections',
    home: 'Home',
    fashion: 'Fashion',
    kids: 'Kids',
    beauty: 'Beauty',
    bags: 'Bags',
    shoes: 'Shoes',
    lifestyle: 'Lifestyle',
    preview: 'Preview',
    marketplace: 'Marketplace',
    featured: 'Featured',
    featuredBrands: 'Featured Brands',
    featuredStores: 'Featured Stores',
    featuredBanners: 'Featured Banners',
    featuredProducts: 'Featured Products',
    media: 'Media',
    imageUploader: 'Image Uploader',
    paylinkGenerator: 'Paylink Generator',
    cpcPaylinksGenerator: 'CPC Paylinks Generator',
    dealPostPaylinksGenerator: 'Deal Post Paylinks Generator',
    otherPaylinksGenerator: 'Other Paylinks Generator',
    list: 'List',
    edit: 'Edit',
    add: 'Add',
    create: 'Create',
    th: 'Thai',
    other: 'Other',
    dynamicCollections: 'Dynamic Collections',
    collections: 'Collections',
    banner: 'Banner',
    pushNotification: 'Push Notification',
    misc: 'Misc',
    jobPostings: 'Job Postings',
    fileList: 'File List',
    goxipPromotion: 'Goxip Promotion',
    editorial: 'Editorial',
    report: 'Report',
    gmvReport: 'GMV',
    dailySalesReport: 'Daily Sales Report',
    monthlyGMVReport: 'Monthly GMV Report',
    adPerformanceReport: 'Ad Performance Report',
    salesReport: 'Sales Report',
    exportRsSaleReport: 'Export RS Sales',
    exportRsPayoutReport: 'Export RS Payout',
    exportMpDeliveryReport: 'Export MP Delivery',
    goxipCircle: 'Goxip Circle',
    rewards: 'Rewards',
    dailyOptIn: 'Daily Opt In',
    pointStatus: 'Point Status',
    rewardsnap: 'rewardSnap',
    orderAppeal: 'Order Appeal',
    store: 'Store',
    storeCountryDetail: 'Store Country Detail',
    benefit: 'Benefit',
    deeplinkGenerator: 'Deeplink Generator',
    orderHistory: 'Order History',
    rewardsnapPayoutMain: 'Payout',
    rewardsnapPayoutOrderPaymentStatusUpload: 'Upload Order Payment Status',
    rewardsnapCampaignPaymentList: 'Campaign Payment List',
    rewardsnapPayoutCampaignPaymentStatusUpload: 'Upload Campaign Payment Status',
    rewardsnapPayoutDownloadUpcomingPayout: 'Download Upcoming Payouts',
    trending: 'Trending',
    topBrandEdit: 'Top Brand Edit',
    topBrandList: 'Top Brand List',
    brandEdit: 'Brand Edit',
    brandList: 'Brand List',
    searchEdit: 'Search Edit',
    marketplaceBrandsList: 'Marketplace Brand List',
    bannerScheduleList: 'Banner Schedule List',
    featuredList: 'Featured List',
    orders: 'Orders',
    seo: 'SEO',
    shopTheLook: 'Shop The Look',
    post: 'Post',
    config: 'Config',
    stickyHomeIds: 'Sticky Home IDs',
    promotionCode: 'Promotion Tags',
    category: 'Category',
    product: 'Product',
    search: 'Search',
    hardcodeProducts: 'Hardcode Products',
    order: 'Order',
    merchants: 'Merchants',
    subscriptions: 'Subscriptions',
    trendingFeeds: 'Trending Feeds',
    productPriceReport: 'Product Price Report',
    uploadMultiple: 'Upload Multiple',
    brand: 'Brand',
    job: 'Job',
    productCat: 'Product Categorization',
    uncategorizedProducts: 'Uncategorized Products',
    edm: 'Edm',
    privateClient: 'Private Client',
    dealPost: 'Deal Post',
    cpcCampaign: 'CPC Campaign',
  },
  login: {
    title: 'Goxip Admin',
    logIn: 'Log in',
    username: 'Username',
    password: 'Password',
    logInToYourAccount: 'Log in to your account',
    signInWithGoogle: 'Sign in with Google',
    loggingYouIn: 'Logging you in...',
  },
  navbar: {
    logout: 'Log Out',
  },
  table: {
    id: 'ID',
    search: 'Search',
    name: 'Name',
    add: 'Add',
    edit: 'Edit',
    delete: 'Delete',
    save: 'Save',
    web: 'Web',
    mobile: 'Mobile',
    bannerIds: 'Banner ID(s)',
    productIds: 'Product ID(s)',
    logo_image: 'Logo Image',
    featured_image: 'Featured Image',
    url: 'URL',
    action: 'Action',
    merchant: 'Merchant',
    description: 'Description',
    productId: 'Product ID',
    salePrice: 'Sale Price',
    type: 'Type',
    detail: 'Detail',
    notificationType: 'Notification Type',
    targetedUser: 'Targeted User',
    createdTime: 'Created Time',
    lastUpdatedTime: 'Last Updated Time',
    result: 'Result',
    newPush: 'New Push Notification',
    newJobPosting: 'New Job Posting',
    basicInfo: 'Basic Information',
    title: 'Title',
    subtitle: 'Subtitle',
    bannerImageUrl: 'Banner Image URL',
    image: 'Image',
    products: 'Products',
    categories: 'Categories',
    availableCountries: 'Available Country(s)',
    enable: 'Enable',
    preferredGender: 'Preferred Gender',
    locations: 'Locations',
    maxCharacters: 'Max. {number} characters',
    redirectFilters: 'Redirect Filters',
    txt_1: 'Txt1',
    txt_2: 'Txt2',
    button: 'Button Text',
    targetUserType: 'Target User Type',
    location: 'Location',
    appPromotionInfo: 'App Promotion Information',
    mainimg: 'Main Image',
    member: 'Member',
    message: 'Message EN',
    message_zh_hk: 'Message ZH HK',
    number_of_likes: 'Likes',
    number_of_comments: 'Comments',
    postId: 'Post ID',
    sort: 'Sort',
    is_show_name: 'Show Name',
    slug: 'Slug',
    create_date: 'Create Date',
    goxip_post_type: 'Type',
    status: 'Status',
    country: 'Country',
    oneLineEdit: 'One-line Edit',
    list: 'List',
    notification_scheduled_at: 'Notification At',
    date: 'Date',
    category: 'Category',
    gender: 'Gender',
    previewToken: 'Preview Token',
    photoCredit: 'Photo Credit(s)',
    sameStoreSimilarProducts: 'Same store, similar products',
    sameProductDifferentStore: 'Same product, different store',
    sameStoreBrand: 'Same store, same brand',
    sameStoreCategory: 'Same store, same category',
    smartLinks: 'Smart Links',
    metaTitle: 'Meta Title',
    metaDescription: 'Meta Description',
    mainImageLink: 'Main Image Link',
    mainImageRatio: 'Main Image Ratio',
    homeImage: 'Home Image',
    coverImage: 'Cover Image',
    author: 'Author',
    avatar: 'Avatar',
    tag: 'Tag(s)',
    enabled: 'Enabled',
    promo_code: 'Code',
    terms: 'Terms',
    start_at: 'Start',
    end_at: 'End',
    priority: 'Priority',
    store_id: 'Store',
    google_category_name: 'Google Category Name',
    breadcrumb: 'Breadcrumb',
    text: 'Text',
    h1_title: 'H1 Title',
    meta_title: 'Meta Title',
    meta_description: 'Meta Description',
    meta_keywords: 'Meta Keywords',
    short_description: 'Short Description',
    channel: 'Channel',
    created_at: 'Created At',
    target_id: 'Target ID',
    push_type: 'Push Type',
    target_push_time: 'Target Push Time',
    banner_id: 'Banner ID',
    bottom_content_block: 'Bottom Content Block',
    page_description: 'Page Description',
    h1: 'h1',
    discount_rate: 'Discount Rate',
    list_price: 'List Price',
    sale_price: 'Sale Price',
    list_price_usd: 'List Price (in USD)',
    sale_price_usd: 'Sale Price (in USD)',
    currency: 'Currency',
    product_id: 'Product ID',
    product_ids: 'Product IDs',
    storeId: 'Store ID',
    brand_name: 'Brand Name',
    store_name: 'Store Name',
    store_displayname: 'Store Name',
    store_type: 'Store Type',
    main_image: 'Main Image',
    in_stock: 'In Stock',
    liked: 'Liked',
    product_type: 'Product Type',
    brand_link: 'Brand Link',
    store_link: 'Store Link',
    shop_link: 'Shop Link',
    similar_link: 'Similar Link',
    product_link: 'Product Link',
    sku: 'SKU',
    brands: 'Brands',
    includeProductIds: 'Include Product IDs',
    excludeProductIds: 'Exclude Product IDs',
    utm_params: 'UTM Parameters',
    order_number: 'Order Number',
    order_date: 'Order Date',
    payment_method: 'Payment Method',
    payment_status: 'Payment Status',
    delivery: 'Delivery',
    discount: 'Discount',
    amount_paid_by_point: 'Amount Paid By Point',
    subtotal: 'Subtotal',
    total: 'Total',
    shipment: {
      shipment_status: 'Shipment Status',
      tracking_url: 'Tracking URL',
      tracking_info: 'Tracking Info',
      tracking_documents: 'Tracking Doc',
    },
    product_name: 'Product Name',
    variant_name: 'Variant',
    unit_price: 'Unit Price',
    quantity: 'Quantity',
    price: 'Price',
    email: 'Email',
    owner_name: 'Owner',
    website: 'Website',
    approved: 'Approved',
    approve: 'Approve',
    approval: 'Approval',
    reject: 'Reject',
    online: 'Online',
    offline: 'Offline',
    facebook: 'Facebook',
    instagram: 'Instagram',
    reject_reason: 'Reject Reason',
    login_email: 'Login Email',
    store_email: 'Store Email',
    username: 'Username',
    legal_name: 'Business Legal Name',
    address: 'Address',
    phone: 'Phone',
    br_number: 'BR Number',
    br_image: 'BR',
    total_products: 'Number of Products',
    shipment_options: 'Shipment Options',
    pickup_options: 'Pickup Options',
    payment_setting: 'Payment Information',
    merchant_terms_version: 'Signed T&C Version',
    merchant_terms_signed_at: 'Signed T&C at (GMT + 0)',
    business_record: 'Business Registry',
    pp20: 'PP20',
    bank: 'Bank Document',
    identity: 'Identity Document',
    fda: 'FDA Document',
    member_id: 'Member ID',
    affiliate_order_id: 'Affiliate Order ID',
    is_valid: 'Valid',
    is_settle: 'Settled',
    is_handling: 'Handling',
    reason: 'Reason',
    remarks: 'Remarks',
    uploads: 'Uploads',
    stores: 'Stores',
    available_countries: 'Available Countries',
    SEO: 'SEO',
    seo: 'SEO',
    brand: 'Brand',
    imageurl: 'Image URL',
    affiliate_refid: 'Affiliate Ref ID',
    keywords: 'Keywords',
    spider_name: 'Spider',
    last_scrapped_at: 'Last Scrapped',
    insert_count: 'Number of Insert',
    success_count: 'Number of Success',
    out_of_stock_count: 'Number of Out of Stock',
    failure_count: 'Number of Failure',
    scrapped_at: 'Scrapped At',
    scrapped_retail_amount: 'Retail Price',
    scrapped_sale_amount: 'Discounted Price',
    images: 'Images',
    try_times: 'Try Times',
    min_price_usd: 'Min Price (in USD)',
    max_price_usd: 'Max Price (in USD)',
    genders: 'Genders',
    discount_from: 'Discount',
    successful_deliveries: 'Successful Delieveries',
    displayname: 'Display Name',
    promotionApplies: 'Promotion Applies to',
    shipping_info: 'Shipping',
    return_policy: 'Return Policy',
    free_shipping_info: 'Free Shipping Info',
    free_return_info: 'Free Return Info',
    is_free_shipping: 'Free Shipping',
    is_free_return: 'Free Return',
    jobType: 'Job Type',
    jobSections: 'Job Sections',
    apply_url: 'Apply URL',
    affiliateCategories: 'Affiliate Categories',
    store: 'Store',
    age: 'Age',
    country_code: 'Country',
    plan_name: 'Plan',
    billing_interval: 'Billing Interval',
    start_date: 'Start Date',
    terminated_date: 'Terminated Date',
    plan_monthly_price: 'Monthly Price',
    next_billing_date: 'Next Billing Date',
    payment_source: 'Payment Source',
    subject: 'Subject',
    publish_at: 'Publish At',
    publish_at_hkt: 'Publish At (HKT)',
    send_count: 'Send Count',
    open_info: 'Open Rate',
    click_info: 'Click Rate',
    home_carousel_banner_ids: 'Carousel',
    home_right_banner_ids: 'WTBN',
    app_promotion_banner_id: 'Highlight of the day',
  },
  tab: {
    home: 'Home',
    fashion: 'Fashion',
    kids: 'Kids',
    beauty: 'Beauty',
    bags: 'Bags',
    shoes: 'Shoes',
    lifestyle: 'Lifestyle',
    preview: 'Preview',
    brands: 'Brands',
    stores: 'Stores',
    marketplace: 'Marketplace',
    website: 'Website',
    app: 'App',
  },
  button: {
    push: 'Push',
    pushing: 'Pushing',
    cancel: 'Cancel',
    save: 'Save',
    copyLang: 'Copy to all languages',
    downloadTemplate: ' or Download the Template',
    delete: 'Delete',
    saving: 'Saving',
    create: 'Create',
    upload: 'Upload',
    addNewItem: 'Add New Item',
    leave: 'Leave',
    ok: 'OK',
    clear: 'Clear',
    generate: 'Generate',
    copy: 'Copy',
    edit: 'Edit',
    search: 'Search',
    generateCSV: 'Generate CSV',
    resetFilter: 'Reset Filter',
    confirm: 'Confirm',
    offlineProduct: 'Offline Product',
    uploadMultiple: 'Upload Multiple',
    addBelow: 'Add Below',
    back: 'Back',
    addSection: 'Add Section',
    seeDetails: 'See Details',
    cannotCategorised: 'Cannot Categorised',
    skip: 'Skip',
    unskip: 'Unskip',
    export: 'Export',
    import: 'Import',
    submit: 'Submit',
    copyToTW: 'Copy to TW',
    requestFullRefund: 'Request Full Refund',
    requestRefund: 'Request Refund',
    confirmRefundRequest: 'Confirm Refund Request',
    confirmFullRefund: 'Confirm Full Refund',
    confirmPartialRefund: 'Confirm Partial Refund',
    validateFullRefund: 'Validate Full Refund',
    validatePartialRefund: 'Validate Partial Refund',
    validateRefund: 'Validate Refund',
  },
  message: {
    leaveWithUnsavedChanges: 'Do you really want to leave? You have unsaved changes!',
    disableBanner: 'Are you sure you want to disable this banner?',
    refreshAndTryAgain: 'Please refresh the browser and try again.',
    confirmToDelete: 'Confirm to delete?',
    confirmToCopy: 'Confirm to copy the selected item?',
    noDataFound: 'No data can be found.',
    confirmToReset: 'Confirm to reset?',
  },
  error: {
    thisFieldIsRequired: 'This field is required.',
    thisFieldMustBeANumber: 'This field must be a number.',
    thisFieldMustBeAProductId: 'Invalid Product ID.',
    thisFieldMustBeAPositiveNumber: 'This field must be a positive number.',
    thisFieldMustBeANonNegativeInteger: 'This field must be a non negative integer.',
    thisFieldMustBeAnUrl: 'This field must be an URL.',
    thisFieldMustBePositiveInteger: 'This field must be a positive integer.',
    thereIsAnErrorInYourInputFormat: 'There is an error in your input format.',
    somethingWentWrong: 'Something went wrong.',
    pleaseSelectCountry: 'Please select at least one country',
    pleaseFillInAndCheckErrors: 'Please fill in all the required information and check if there are any errors',
    bannerNotFound: 'Sorry, the banner was not found!',
    fullscreenNotSupported: 'Sorry, you browser does not support the full screen feature.',
    errorDate: 'Error Date',
    thisFieldShouldContainValidURL: 'This field should contain valid URL',
    thisFieldShouldContainValidImageURL: 'This field should contain valid image URL',
    youCanOnlyInput4Ids: 'You can only enter 4 ids',
    errorSigningInToGoogle: 'Error signing in to Google',
    seoNotFound: 'Sorry, the Seo was not found!',
    brandNotFound: 'Sorry, the brand is not found!',
    shopTheLookNotFound: 'Sorry, the shop the look item is not found!',
    configNotFound: 'Sorry, config is not found!',
    categoryNotFound: 'Sorry, category is not found!',
    hardcodeNotFound: 'Sorry, hardcode record is not found!',
    trendingFeedNotFound: 'Sorry, the trending feed is not found!',
    recordNotFound: 'Sorry, the record is not found!',
    NOTIFICATION_CANNOT_BE_DELETED: 'Notification cannot be deleted.',
    invalidUsername: 'Invalid Username',
    memberUsernameExist: 'Member Username being used',
    memberEmailExist: 'Member Email being used',
    storeSlugExist: 'Store Slug being used',
    TRENDING_FEED_TOO_FEW_RESULTS: 'Too few products match the trending feed criteria.',
    TRENDING_FEED_SIMILAR: 'Too similar to an existing feed.',
    noMoreThanTenId: 'Please input no more than 11 ids e.g. 1 cover id + 10 post ids.',
    youHaveNotSaved: 'Oops! You have not saved. Do you confirm to search?',

  },
  success: {
    successfullyPushedNotification: 'Successfully pushed notification.',
    savedSuccessfully: 'Saved Successfully.',
    successfullyDeletedPushNotification: 'Successfully deleted push notification.',
  },
  placeholder: {
    pleaseEnterAnUrl: 'Please input an url.',
    selectType: 'Select Type',
    select: 'Select',
    bannerTitle: 'Banner Title',
    bannerDescription: 'Banner Description',
    pickDay: 'Pick a day',
    enterStore: 'Enter store name',
    enterSlugToSearchCategory: 'Enter slug to search for category',
    selectDateForQuery: 'Select a date for query',
    enterBrand: 'Enter brand name',
    enterProduct: 'Enter product name',
  },
  common: {
    en: 'EN',
    zhHK: 'HK',
    zhCN: 'CN',
    zhTW: 'TW',
    th: 'TH',
    enAu: 'EN_AU',
    enId: 'EN_ID',
    enMy: 'EN_MY',
    enPh: 'EN_PH',
    enSg: 'EN_SG',
    enTh: 'EN_TH',
    enGb: 'EN_GB',
    enUs: 'EN_US',
    enTw: 'EN_TW',
    optional: 'Optional',
    required: 'Required',
    women: 'Women',
    men: 'Men',
    kids: 'Kids',
    error: 'Error',
    warning: 'Warning',
    backToTop: 'Back to Top',
    oops: 'Oops..',
    categories: 'Categories',
    brands: 'Brands',
    stores: 'Stores',
    yes: 'Yes',
    no: 'No',
    update: 'Update',
  },
  select: {
    noOptionsFound: 'No options found.',
    deselect: 'Deselect',
  },
  date: {
    yesterday: 'Yesterday',
    last7Days: 'Last 7 Days',
    thisWeek: 'This Week',
    lastWeek: 'Last Week',
    thisMonth: 'This Month',
    lastMonth: 'Last Month',
    last30Days: 'Last 30 Days',
    custom: 'Custom',
  },
  file: {
    dropFileHereOrClickUpload: 'Drop file here or <em>click to upload</em>',
    sizeLessThan100MB: 'Files with a size less than 100MB',
    explainUpload: 'Upload a .csv file to add multiple trends simultaneously',
    dropCsvFileHereOrClickUpload: '<b>Drop .csv file here or <em>click to upload</em></b>',
  },
  featured: {
    referenceIds: 'Reference IDs',
    home_carousel: 'Home - Top Carousel',
    home_editorials: 'Home - Magazine',
    home_slide_banners: 'Home - What To Buy Now',
    marketplace_carousel: 'Marketplace - Top Carousel',
    magazines: 'Magazine',
    all: 'All',
    platform: 'Platform',
    app: 'App',
    web: 'Web',
    type: 'Type',
    followHk: 'Follow HK',
    marketplace_featured_brands: 'Marketplace Featured Brands',
  },
  bannerLocation: {
    all: 'All',
    allExcludingTh: 'All excluding TH',
    th: 'TH only',
    unknown: 'Unknown',
  },
  userType: {
    all: 'All',
    members: 'Members',
    guests: 'Guests',
    unknown: 'Unknown',
  },
  config: {
    sticky_home_ids: 'Sticky Home IDs',
    sticky_home_ids_desc: 'The following list of ids will be displayed at the top of apps home page',
    ignore_users: 'Ignore Users',
    ignore_users_desc: 'The following list of ids will be ignored from all reports',
  },
  promoCode: {
    addNewPromoCode: 'Add New Promo Code',
    promotionCodes: 'Promotion Codes',
    selectStore: 'Select store',
  },
  form: {
    addMoreLanguages: 'Add more languages',
  },
  notification: {
    all: 'All Users',
    member: 'Members Only',
    member_87: 'Guest Only',
  },
  hardcode: {
    selectTheRuleType: 'Select the type of hardcode product rule:',
    overrideProductPrice: 'Override product price',
    overrideStorePrices: 'Override all prices for a store',
    forceOnline: 'Force Online',
    newProduct: 'New Product',
    offlineProduct: 'Offline Product',
    offlineFollowingProduct: 'Offline the following product',
    productOfflineSuccessfully: 'Product (ID: {productId}) has become offline successfully',
    productCreateSuccessfully: 'Product (ID: {productId}) has been created successfully',
  },
  mpOrder: {
    statistics: 'Statistics',
    orderDetail: 'Order Detail',
    all: 'All',
    goxip: 'Goxip',
    rewardsnap: 'RewardSnap',
    ios: 'iOS',
    android: 'Android',
    web: 'Web',
    dateRange: 'Date Range',
    country: 'Country',
    currency: 'Currency',
    goxipPlatform: 'Goxip Platform',
    platform: 'Platform',
    merchant: 'Merchant',
    orderNumber: 'Order Number',
  },
  dialog: {
    confirm: 'Confirm',
    confirmToDelete: 'Confirm to delete?',
  },
  store: {
    countryDetail: 'Country Detail',
    selectNewCountryToAdd: 'Select new country to add:',
  },
  job: {
    noJobSections: 'Currently no job sections. Please add one.',
  },
  dateRange: {
    dateRange: 'Date Range',
    startDate: 'Start Date',
    to: 'To',
    endDate: 'End Date',
  },
}
